query ListParameters {
    parameters {
        id

        name(language: "en") {
            text
        }

        group {
            id
        }
    }
}
